import { AnyAction } from 'redux';
import { SearchReducerState } from '../../../interfaces';
import { SET_SEARCH_RESULT_BASEPATH, CLEAR_SEARCH_RESULT_BASEPATH } from '../actions';

export function searchReducer(
  state: SearchReducerState = {
    fromBasePath: '',
  },
  action: AnyAction,
) {
  switch (action.type) {
    case SET_SEARCH_RESULT_BASEPATH:
      return {
        ...state,
        fromBasePath: action.fromBasePath,
      };
    case CLEAR_SEARCH_RESULT_BASEPATH:
      return {
        ...state,
        fromBasePath: action.fromBasePath,
      };
    default:
      return state;
  }
}
